export default __webpack_public_path__ + "static/media/watch-sun.30cb8a94.jpg";